
 let img1 = "https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/Not_unlocked_bt-min.png";//未解锁宝塔舍利
 let img2 = "https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/Not_unlocked_hs-min.png";//未解锁华山之巅
 let img47 = "https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/1-1.png";//未解锁华山之巅
 let img3 = "https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/share-min.png";//分享好友
 let img4 = "https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/synthesis-min.png";//等待合成
 let img5 = "https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/synthesis_11-min.png";//立即合成
 let img6 = "https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/unlocked-min.gif";//已解锁
 let img7 = "https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/unlocked_cz-min.gif";//解锁晨钟暮鼓
 let img8 = "https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/unlocked_hs-min.gif";//解锁华山之巅
 let img9 = "https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/unlocked_sl-min.gif";//解锁宝塔舍利
// about
 let img10 = "https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/About/About-min.png";//分享
 let img11 = "https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/About/bt-min.png";//宝塔
 let img12 = "https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/About/hs-min.png";//华山
 let img13 = "https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/About/mz-min.png";//暮鼓
 let img14 = "https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/About/me-min.png";//我的奖励
 let img15 = "https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/About/open-min.png";//开启宝箱
// mod
 let img16 = "https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/About/receive-min.png";//领取
 let img17 = "https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/About/aq-min.png";//爱情
 let img18 = "https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/About/sy-min.png";//事业
 let img19 = "https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/About/jk-min.png";//健康
 let img20 = "https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/emoji-min.gif";//哭脸
 let img21 = "https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/jh-min.png";//合成集合
 let img22 = "https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/hecheng2-min.png";//合成btn
 let img23 = "https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/more-min.png";//再来一次
 let img24 = "https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/quan-min.png";//卡券
 let img25 = "https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/1000-min.png";//1000元现金
 let img26 = "https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/zyz-min.png";//黄金转运珠
 let img27 = "https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/yst-min.png";//养生堂护手霜
 let img28 = "https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/mm-min.png";//薇诺娜面膜礼盒
 let img29 = 'https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/fxyd-min.png';//分享引导
 let img30 = "https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/Not_unlocked-min.png";//未解锁11宝箱
 let img31 = "https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/unlocked-min.gif";//解锁11宝箱
 let img32 = 'https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/ej12.png';//东阿阿胶铁盒12优惠券
 let img33 = 'https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/hq30.png';//黄芪精30
 let img34 = 'https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/c5.png';//天然维生素C5
 let img35 = 'https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/ya130.png';//益安宁丸130
 let img36 = 'https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/lg80.png';//龙牡壮骨颗粒80
 let img37 = 'https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/ys10.png';//雅塑奥利司他胶囊10
 let img38 = 'https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/ej20.png';//复方阿胶浆20
 let img39 = 'https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/tc30.png';//汤臣倍健蛋白粉30
 let img40 = 'https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/50.png';//通用50券
 let img41 = 'https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/10.png';//通用10券
 let img42 = 'https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/mn10.png';//米诺地尔酊10元优惠
 let img43 = 'https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/yw50.png';//燕窝50元优惠券
 let img44 = 'https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/sb10.png';//肾宝片10元优惠券
 let img45 = 'https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/ej50.png';//阿胶50元优惠券
 let img46 = 'https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/jq.png';//奖品记录
 let img48 = 'https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/xbgz.png';//奖品记录
const img = {
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    //  About
    img10,
    img11,
    img12,
    img13,
    img14,
    img15,
    // mod
    img16,
    img17,
    img18,
    img19,
    img20,
    img21,
    img22,
    img23,
    img24,
    img25,
    img26,
    img27,
    img28,
    img29,
    img30,
    img31,
    img32,
    img33,
    img34,
    img35,
    img36,
    img37,
    img38,
    img39,
    img40,
    img41,
    img42,
    img43,
    img44,
    img45,
    img46,
    img47,
    img48,
}
export default img